/**
 * 传媒报道
 * Created at 2021-10-03 13:19
 * @author teapot
 */
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import Api from "../../api";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import HeadView from "../../components/head/HeadView";
import Config from "../../config";
import { mediaAsync, resetNews, setNewsSort, setNewsTime } from "../../store/OtherStore";
import "./index.css";
import NewsItem from "./NewItem";
import { Pagination } from 'antd';
import React from 'react';

import MediaAddress from "./MediaAddress";
import { useStore } from "react-redux";
import { clearTimeout } from "timers";
import { current } from "@reduxjs/toolkit";

declare global {  //设置全局属性
  interface Window {  //window对象属性
    timer: any   //加入对象
  }
}
const Media = () => {
  let [page, setPage] = useState(0)
  let [pageSize, setpPageSize] = useState(9)
  let [currentpage, setCurrentpage] = useState(1)
  let [currentValue,setValue]=useState(0)
  let NewItemRef: any = React.createRef()

  const change = (page: any) => {
    setPage(page * 10 - 10)
    setpPageSize(page * 10 - 1)
    setCurrentpage(page)
  }
  const { newsList, newsPic, newCategory, newSort, newTime ,newInfo,newmediaPdf} = useAppSelector(
    (state: RootState) => state.other
  );
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  console.log(newInfo);
  
  let tot = 0;
  newsList.forEach((item) => {
    tot += item.articles.length
  });
  const Fenye = () => {
    return <Pagination style={{ marginTop: '10px' }}
      defaultPageSize={10} current={currentpage} total={tot} 
      showTotal={total => `共${total}篇文章`} 
      onChange={change} />
  };
  useEffect(() => {
    dispatch(resetNews());
    dispatch(mediaAsync({ page: 1, category: 0, time: 0 }));
  
    

  }, [dispatch,]);
  return (
    <div className="news">
      <MediaAddress ></MediaAddress>
      {/* <div className="line"></div> */}
      <HeadView
        title={t('nav_multimedia')}
        subTitle={t("nav_multimedia_media")}
        imgs={`${Config.MAIN_URL}${newsPic}`}
        list={newCategory}
        dfValue={currentValue}
        onData={(date: any,dateString: any)=>{
            console.log(date);
            console.log(dateString);
            setPage(0)
            setpPageSize(9)
            setCurrentpage(1)
            dispatch(mediaAsync({ page: 1, category: 0, time: newTime, year:dateString}))
        }}
        onPress={(value: string) => {
          console.log('dad');

          const obj = JSON.parse(value);


          if (obj.k === 0) {
            setPage(0)
            setpPageSize(9)
            setCurrentpage(1)
            setNewsSort(obj.v);
            dispatch(mediaAsync({ page: 1, category: obj.v, time: newTime }))
          } else {
            setNewsTime(obj.v);
            dispatch(mediaAsync({ page: 1, category: newSort, time: obj.v }))
          }
        }}
      />
       <div className="newsIntro newsIntromove">
            {localStorage.getItem("i18nextLng") === 'zh-HK' ?
              `傳媒查詢：如對我們的倡議和所關注的議題作更深入的了解,
歡迎致電${newInfo.phone}或電郵至 ${newInfo.email} 與我們聯絡`
              : `传媒查询：如对我们的倡议和所关注的议题作更深入的了解，
欢迎致电${newInfo.phone} 或电邮至${newInfo.email}与我们联络`
            }
          </div> 

      {newsList &&
        newsList.map((item, index) => {
          return <NewsItem  props={item} key={index} api={Api.media_details} page={page} pageSize={pageSize}  />;
        })}
      <Fenye ></Fenye>
    </div>
  );
};



export default Media;



